import React, { useState } from "react"
import styled, { css } from "styled-components"

import { limeFaded, sunnyFaded } from "styles/colors"
import * as spacings from "styles/spacing"
import { Link } from "gatsby"
import { FormattedMessage } from "react-intl"
import Close from "images/close.png"
import Burger from "images/burger.png"

const Trigger = styled.div`
  position: absolute;
  top: -10px;
  right: -22px;
  z-index: 1000;
  cursor: pointer;
  visibility: hidden;
  opacity: 0;
  transition: all 0.1s;

  img {
    width: 120px;
  }

  ${props =>
    props.visible &&
    css`
      visibility: visible;
      opacity: 1;
    `}
`

const Container = styled.div`
  visibility: hidden;
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: -webkit-linear-gradient(
    0deg,
    ${limeFaded} 0%,
    ${sunnyFaded} 100%
  );
  padding: ${spacings.xLarge} 42px;
  z-index: 2000;
  transition: all 0.3s;

  ${props =>
    props.visible &&
    css`
      visibility: visible;
      opacity: 1;
    `}
`

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: ${spacings.xxxLarge};
`

const CloseTrigger = styled.div`
  position: absolute;
  top: -10px;
  right: -22px;
  cursor: pointer;

  img {
    width: 110px;
  }
`

const MenuItem = styled.div`
  font-size: 32px;
  font-family: "Local Charter";
  font-style: italic;
  margin-bottom: ${spacings.medium};
  z-index: 100;
  color: white;
  font-weight: 700;
  text-shadow: 0px 4px 50px rgba(42, 31, 119, 0.5);
`

export default () => {
  const [visible, setVisible] = useState(false)

  return (
    <>
      <Trigger
        visible={!visible}
        onClick={() => {
          setVisible(true)
        }}
      >
        <img src={Burger} />
      </Trigger>
      <Container visible={visible}>
        <Inner>
          <CloseTrigger
            onClick={() => {
              setVisible(false)
            }}
          >
            <img src={Close} />
          </CloseTrigger>
          <MenuItem>
            <Link href="https://ninkitbaby.tumblr.com">
              <FormattedMessage id="home.menu.tumblr" />
            </Link>
          </MenuItem>
          <MenuItem>
            <Link href="https://www.instagram.com/ninkitbaby">
              <FormattedMessage id="home.menu.instagram" />
            </Link>
          </MenuItem>
          <MenuItem>
            <Link href="mailto:contact@nink.app">
              <FormattedMessage id="home.menu.contact" />
            </Link>
          </MenuItem>
          <MenuItem
            onClick={() => {
              setVisible(false)
            }}
          >
            <Link href="#about">
              <FormattedMessage id="home.menu.about" />
            </Link>
          </MenuItem>
        </Inner>
      </Container>
    </>
  )
}
